import {useEffect} from 'react';
import {getNotificationFromIdAPI, useAPI} from '../../services/api';
import {useLoading} from '../../services/hooks';
import NotificationDetails from './NotificationDetails';
import {useParams} from 'react-router-dom';

export default function NotificationDetailsPage() {
  const getNotiApi = useAPI(getNotificationFromIdAPI);
  const {id} = useParams();
  useEffect(() => {
    getNotiApi.request({id: Number(id)});
  }, []);
  useLoading(getNotiApi.loading);

  return getNotiApi.data?.notification ? (
    <NotificationDetails notification={getNotiApi.data?.notification} />
  ) : (
    <div></div>
  );
}
